<template>
	<div id="attributeModal" style="display: block" class="modal" role="dialog">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog" id="attributeInner">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="titleModal">Select {{ type }}</h4>
					<b-button class="btnSize addBtn" @click="addAttribute()">
						New {{ type }}
					</b-button>
				</div>
				<div class="modal-body">
					<div class="search-input-area">
						<font-awesome-icon :icon="['fas', 'search']" class="search-icon" />
						<input
							type="text"
							:placeholder="'Search ' + type"
							class="form-control block search-input"
							v-on:input="searchAttribute($event.target.value)"
						/>
					</div>
					<div class="tableSection">
						<div
							class="cellContainer block"
							v-for="(attributeItem, attributeKey) in attributes"
							:key="attributeKey"
							:class="{
								selected: selectedAttribute == attributeItem,
								['category' + attributeItem.icon]: type == 'Category',
								paymenttype: type === 'Payment Method'
							}"
							tabindex="1"
							@click="$emit('selectDone', attributeItem)"
						>
							<div
								class="icon"
								v-if="type == 'Category' || type == 'Payment Method'"
								:style="
									type == 'Payment Method'
										? 'background-color: ' + attributeItem.ColorTranslucent
										: ''
								"
							>
								<div class="glyph"></div>
							</div>
							<div class="details">
								<div class="title attribute">{{ attributeItem.Name }}</div>
								<font-awesome-icon
									:icon="['fas', 'check-circle']"
									class="selectedIcon"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<b-button class="btnSize cancelBtn" @click="$emit('close')">
						Cancel
					</b-button>
				</div>
			</div>
		</div>
		<CreateAttribute
			v-if="isCreate"
			id="createAttributeModal"
			@created="created"
			@close="isCreate = false"
			:type="type"
		/>
	</div>
</template>

<script>
import CreateAttribute from "./CreateAttribute";
window._ = require("lodash");

export default {
	name: "Attribute",
	props: ["selectedAttributeName", "type"],
	data() {
		return {
			isCreate: false,
			selectedAttribute: null,
			original_attributeArr: [],
			attributes: []
		};
	},
	components: {
		CreateAttribute
	},
	computed: {},
	mounted() {
		this.original_attributeArr = this.getAttributes();
		this.attributes = this.original_attributeArr;
		if (!this.$store.state.attributes.attribute)
			this.$store.dispatch("loadAttribute");
	},
	methods: {
		getAttributes() {
			if (this.$store) {
				var self = this;
				let attributeType = this.type.replace(/\s/g, "").toLowerCase();

				return _.sortBy(
					this.$store.state.attributes[
						attributeType === "paymentmethod" ? "paymenttype" : attributeType
					],
					[
						function(data) {
							data["icon"] = self.getCategoryIcon(data["Name"]);
							if (
								self.selectedAttributeName &&
								data.Name == self.selectedAttributeName
							) {
								self.selectedAttribute = data;
							}
							return data.Sort;
						}
					]
				);
			}
			return [];
		},
		addAttribute() {
			this.isCreate = true;
		},
		created(attributeName) {
			this.isCreate = false;
			this.$emit("selectDone", { Name: attributeName });
		},
		searchAttribute(keyword) {
			const self = this;
			if (keyword) {
				clearInterval(this.pendingCheck);
				if (this.attributes.length < 1) {
					this.attributes = this.original_attributeArr;
				}
				let filteredData = _.filter(this.attributes, function(result) {
					if (_.includes(result.Name.toLowerCase(), keyword.toLowerCase())) {
						return result;
					}
				});
				this.attributes = _.sortBy(filteredData, [
					function(data) {
						return data.Name;
					}
				]);
			} else {
				this.attributes = this.original_attributeArr;
			}
		}
	}
};
</script>
